document.addEventListener("DOMContentLoaded", function () {

  // ----------------------------
  // スムーズスクロール
  // ----------------------------
  document.querySelectorAll('a[href^="#"]').forEach(function (aTag) {
    aTag.addEventListener("click", function (e) {
      e.preventDefault();
      const href = this.getAttribute("href");
      const target = document.querySelector(href === "#" || href === "" ? "html" : href);

      if (!target) return;

      const position = target.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });
    });
  });


  // ----------------------------
  // スマホのみ TEL リンク付与
  // ----------------------------
  const ua = navigator.userAgent;
  if (
    ua.indexOf("iPhone") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
  ) {

    document.querySelectorAll(".tel_link").forEach(function (el) {
      const teltext = el.textContent;
      const telnum = teltext.replace(/[^0-9]/g, "");

      const link = document.createElement("a");
      link.href = "tel:" + telnum;
      link.innerHTML = el.innerHTML;

      el.innerHTML = "";    // 元を消す
      el.appendChild(link); // 追加
    });
  }


  // ----------------------------
  // FAQ アコーディオン
  // ----------------------------
  if (document.querySelector(".faq_block")) {

    // .body 初期非表示
    document.querySelectorAll(".faq_block .body").forEach(function (body) {
      body.style.display = "none";
    });

    // activeのついてるものだけ表示
    document.querySelectorAll(".faq_block .head.active").forEach(function (head) {
      const body = head.nextElementSibling;
      if (body && body.classList.contains("body")) {
        body.style.display = "block";
      }
    });

    // クリック処理
    document.querySelectorAll(".faq_block .head").forEach(function (head) {
      head.addEventListener("click", function () {
        const body = this.nextElementSibling;

        if (!body) return;

        if (this.classList.contains("active")) {
          this.classList.remove("active");
          body.style.display = "none";
        } else {
          this.classList.add("active");
          body.style.display = "block";
        }
      });
    });
  }

});
